import { FC } from 'react';
import { Modal, Button } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../../../Localization';
import DialPad from '../../../../../../Components/DialPad';

interface PhoneKeypadModalProps {
  open: boolean;
  onClose: () => void;
  onDigit: (digit: string) => void;
}

/**
 * Modal displaying phone keypad for DTMF input during active call
 */
export const PhoneKeypadModal: FC<PhoneKeypadModalProps> = ({
  open,
  onClose,
  onDigit
}) => {
  const L = useLocalizedStrings();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={L.applicant.comms.keypad}
      size="sm"
    >
      <div className="mt-2">
        <DialPad onDigit={onDigit} />
      </div>
      <div className="mt-4 text-center">
        <Button variant="secondary" onClick={onClose} className="w-full">
          {L.component_library.modal.close}
        </Button>
      </div>
    </Modal>
  );
};
